import { boolean, mixed, number, object, string, array } from "yup";
var AttributionCategoryTypeEnum = /* @__PURE__ */ ((AttributionCategoryTypeEnum2) => {
  AttributionCategoryTypeEnum2[AttributionCategoryTypeEnum2["PaidBy"] = 1] = "PaidBy";
  AttributionCategoryTypeEnum2[AttributionCategoryTypeEnum2["AdjustmentReason"] = 2] = "AdjustmentReason";
  return AttributionCategoryTypeEnum2;
})(AttributionCategoryTypeEnum || {});
var AttributionCategoryParentEnum = /* @__PURE__ */ ((AttributionCategoryParentEnum2) => {
  AttributionCategoryParentEnum2["Corporate"] = "Corporate";
  AttributionCategoryParentEnum2["General"] = "General";
  AttributionCategoryParentEnum2["Branch"] = "Branch";
  return AttributionCategoryParentEnum2;
})(AttributionCategoryParentEnum || {});
const AttributionCategoryDto = object({
  attributionCategoryTypeID: number().oneOf([
    1 /* PaidBy */,
    2 /* AdjustmentReason */
  ]).required(),
  deleted: boolean().default(false).required(),
  guid: string().optional(),
  name: string().optional().required("Name is required").max(20).test("unique-category-name", "Name must be unique", (value, context) => {
    let namesInFormData = context?.from?.[1]?.value.data.map(
      (i) => i.name
    );
    if (context.options.context.updatingExistingCategory) {
      namesInFormData = namesInFormData.filter(
        (i) => i !== context.options.context.updatingExistingCategory.name
      );
    }
    const existingNames = [
      ...context.options.context.existingCategoryNames,
      ...namesInFormData ?? []
    ];
    return existingNames.map((i) => i.toLowerCase()).filter((n) => n === value.toLowerCase()).length < 2;
  }),
  abbreviation: string().max(4).required("Abbreviation is required").test(
    "no-hyphen-in-abbreviation",
    'Abbreviation cannot contain "-"',
    (value) => !/[‐‑–—−-]/.test(value)
  ).test(
    "unique-category-abbreviation",
    "Abbreviation must be unique",
    (value, context) => {
      let abbreviationsInFormData = context?.from?.[1]?.value.data.map(
        (i) => i.abbreviation
      );
      if (context.options.context.updatingExistingCategory) {
        abbreviationsInFormData = abbreviationsInFormData.filter(
          (i) => i !== context.options.context.updatingExistingCategory.abbreviation
        );
      }
      const existingAbbreviations = [
        ...context.options.context.existingCategoryAbbreviations,
        ...abbreviationsInFormData ?? []
      ];
      return existingAbbreviations.map((i) => i.toLowerCase()).filter((n) => n === value.toLowerCase()).length < 2;
    }
  ),
  parent: array(
    mixed().oneOf(
      Object.values(AttributionCategoryParentEnum)
    )
  ).optional()
});
const AttributionCategoryFormObject = object({
  data: array().of(AttributionCategoryDto)
});
export {
  AttributionCategoryDto,
  AttributionCategoryFormObject,
  AttributionCategoryParentEnum,
  AttributionCategoryTypeEnum
};
